import { TPPAdapters } from '@seapoint/server/enums';
import { Navigate, Route, Routes } from 'react-router';
import AccountsPage from '../pages/accounts/accounts-page';
import { AccountsRoutesWrapper } from '../pages/accounts/sections/accounts-routes-wrapper';
import { ConnectedAccountsPageWrapper } from '../pages/accounts/sections/connected-accounts-page.tsx/connected-account-page-wrapper';
import { OpenAccountPage } from '../pages/accounts/sections/open-account-page/open-account-page';
import { OpenBankingPageWrapper } from '../pages/accounts/sections/open-banking-page/connect-open-banking-page-wrapper';
import { IntegrationsPageWrapper } from '../pages/integrations/integrations-page-wrapper';
import { InvoicePayPageOuterWrapper } from '../pages/invoice-pay/invoice-pay-page-outer-wrapper';
import Layout from '../pages/layout/layout';
import { ManageMembersPage } from '../pages/members/manage-members-page';
import { NoMatch } from '../pages/no-match/no-match';
import { PaymentsPage } from '../pages/payments/payments-page';
import { PayrollPage } from '../pages/payroll/payroll-page';
import { ReachoutPage } from '../pages/reachout/reachout';
import ReportingPage from '../pages/reporting/reporting-page';
import OrganisationSettingsPage from '../pages/settings/organisation-settings';
import CreateCompany from '../pages/signup/create-company';
import { SignupPage } from '../pages/signup/signup-page';
import VerifyEmail from '../pages/signup/verify-email';
import { TPPConsentPage } from '../pages/tpp/consent-page';
import ConsentResultPage from '../pages/tpp/consent-result-page';
import TransactionsPage from '../pages/transactions/transactions-page';
import { ProtectedRoute } from './protected-route';

export const AppRoutes = () => {
  return (
    <Routes>
      {/* Protected signup routes */}
      <Route path="/signup" element={<ProtectedRoute element={<SignupPage />} requiresCompleteSignup={false} />}>
        <Route path="verifyemail" element={<VerifyEmail />} />
        <Route path="organisation" element={<CreateCompany />} />
      </Route>

      {/* Protected dashboard routes */}
      <Route path="/dashboard" element={<ProtectedRoute element={<Layout />} />}>
        <Route index element={<Navigate to="/dashboard/transactions" replace />} />
        <Route path="transactions" element={<TransactionsPage />} />
        <Route path="accounts" element={<AccountsPage />}>
          <Route index element={<AccountsRoutesWrapper />} />
          <Route path="open-seapoint-account" element={<OpenAccountPage />} />
          <Route path="connect-open-banking" element={<OpenBankingPageWrapper />} />
          <Route path="connected-accounts" element={<ConnectedAccountsPageWrapper />} />
        </Route>
        <Route path="payments" element={<PaymentsPage />} />
        <Route path="invoice-pay" element={<InvoicePayPageOuterWrapper />} />
        <Route path="reporting" element={<ReportingPage />} />
        <Route path="team" element={<ManageMembersPage />} />
        <Route path="payrolls">
          <Route index path="*" element={<PayrollPage />} />
        </Route>
        <Route path="integrations">
          <Route index element={<IntegrationsPageWrapper />} />
          <Route path=":oauthProvider" element={<IntegrationsPageWrapper />} />
        </Route>
      </Route>

      {/* Protected settings routes */}
      <Route path="/settings" element={<ProtectedRoute element={<Layout />} />}>
        <Route path="organisation" element={<OrganisationSettingsPage />} />
      </Route>

      {/* Redirect root to dashboard */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      {/* TPP consent route */}
      <Route path="/tpp" element={<ProtectedRoute element={<></>} />}>
        <Route path="uk/consent" element={<TPPConsentPage adapter={TPPAdapters.TELL_MONEY_UK} />} />
        <Route path="eu/consent" element={<TPPConsentPage adapter={TPPAdapters.TELL_MONEY_EU} />} />
        <Route path="consent/result" element={<ConsentResultPage />} />
      </Route>

      <Route path="/reachout" element={<ReachoutPage />} />

      {/* Catch-all route for unknown paths */}
      <Route path="*" element={<NoMatch />} />
    </Routes>
  );
};
